import app from '../common_app.es6';

app.filter('htmlSafe', ['$sce', function ($sce) {
  return function(html) { return $sce.trustAsHtml(html); };
}]);